import * as React from 'react'

import {
  Container,
  Grid,
  Box,
  Text,
  Heading,
} from '@moonpig/launchpad-components'
import { BlockLayout } from '@moonpig/launchpad-find'
import { items1, items2, items3, items4, items5 } from './cardsIndexItems'

const MainTitle = ({ children }) => (
  <Heading
    level="h1"
    textAlign="center"
  >
    {children}
  </Heading>
)
const createMarkup = (html) => ({ __html: html })

// eslint-disable-next-line no-unused-vars
const SeoCopy = () => {
  const items = [
    {
      title: 'Personalised Birthday Cards!',
      content:
        'Celebrate all their magical moments with one of our brilliant personalised birthday cards. Whether you want to make it custom with their name, upload a photo, or add your own handwritten message you can do it all at Moonpig.',
    },
    {
      title: 'Fabulous Birthday Cards For Your Favourite People',
      content:
        'Make their birthday card as unique as they are. Whether you’re personalising a cute <a title="Tatty Teddy Birthday Cards" href="https://www.moonpig.com/uk/search/facet/?f=occasion_level_2:occasion>birthday&amp;q=tatty+teddy">Tatty Teddy</a> card for mum, a funny card for dad, or a glittery fold-out card for your bestie, we have a perfect birthday card designed just for them. There’s also a wide range of birthday party invitations and milestone cards for all those big occasions, such as 21st birthdays, 30th birthdays, 50th birthdays, and even turning 100 birthday cards.',
    },
    {
      title: 'Check Out Our Range Of Cool Birthday Cards',
      content:
        'There’s so much to love about our funny, cute, and photo upload cards, but we also have hundreds of designs from our favourite brands. From&nbsp;<a title="Batman Birthday Cards" href="https://www.moonpig.com/uk/search/facet/?f=occasion_level_2:occasion>birthday&amp;q=batman">Batman</a>&nbsp;and Spiderman to Wonder Women and The Incredible Hulk, we have all the best action heroes. There’s also tons of&nbsp;<a title="Star Wars Cards" href="https://www.moonpig.com/uk/search/facet/?f=occasion_level_2:occasion>birthday&amp;q=star+wars">Star Wars</a>&nbsp;and Game of Thrones birthday cards and a wide range of birthday cards for kids with&nbsp;<a title="Frozen Birthday Cards" href="https://www.moonpig.com/uk/search/facet/?f=occasion_level_2:occasion>birthday&amp;q=frozen">Frozen</a>, Trolls, Paddington, and The Little Mermaid.',
    },
    {
      title: 'Give Them The Best Birthday Present Ever',
      content:
        'Your one-of-a-kind birthday card will be in good company with one of our personalised gifts. Show them you know them with custom bottles of Champagne and beer, one of our new custom tote bags, or a canvas wall print. There’s also hundreds of unique gifts from Sara Miller, Baylis & Harding, Joma Jewellery, Coco Chocolatier, and more. ',
    },
  ]
  return (
    <Grid gap pb={9}>
      {items.map(({ title, content }, key) => (
        // eslint-disable-next-line react/no-array-index-key
        <Box key={key} width={{ xs: 1, md: 1 / 2 }}>
          <Heading level="h3" mb={4}>
            {title}
          </Heading>
          <Text as="p">
            <span dangerouslySetInnerHTML={createMarkup(content)} />
          </Text>
        </Box>
      ))}
    </Grid>
  )
}

const Section = ({ children }) => (
  <Box as="section" mb={{ xs: 9, md: 10 }}>
    {children}
  </Box>
)

const Title = ({ children }) => (
  <Heading level="h2" textAlign="center" mb={4}>
    {children}
  </Heading>
)

const Description = ({ children }) => (
  <Text
    as="p"
    textAlign="center"
    mb={{ xs: 6, md: 7 }}
    mx="auto"
    maxWidth="48em"
  >
    {children}
  </Text>
)

export const CardsIndexPage = () => {
  return (
      <Box pt={{ xs: 7, md: 8 }}>
        <MainTitle>Personalised Birthday Cards</MainTitle>
        <Section>
          <BlockLayout layout="c" items={items1} />
        </Section>
        <Section>
          <Title>Browse Birthday Cards</Title>
          <Description>
            Put a smile on their face with our wide range of funny, cute,
            milestone, and photo birthday cards.
          </Description>
          <BlockLayout layout="g" items={items2} />
        </Section>
        <Section>
          <Title>Birthday Cards By Themes</Title>
          <Description>
            Make their special moment simply out of this world with one of our
            personalised birthday cards. We have many types of styles, designs,
            sizes, and photo upload cards that are just as unique as they are.
          </Description>
          <BlockLayout layout="g" items={items3} />
        </Section>

        <Section>
          <Title>Personalised Cards By Style & Size</Title>
          <Description>
            From larger-than-life giant cards to custom party invitations, we
            have a selection of personalised cards in all kinds of shapes,
            formats, and designs.
          </Description>
          <BlockLayout layout="g" items={items4} />
        </Section>

        <Section>
          <Title>Personalised Cards By Style & Size</Title>
          <Description>
            From larger-than-life giant cards to custom party invitations, we
            have a selection of personalised cards in all kinds of shapes,
            formats, and designs.
          </Description>
          <BlockLayout layout="h" items={items5} />
        </Section>

        <SeoCopy />
      </Box>
  )
}
